import { db } from '@/data/firebase/config';
import { ProtectedComponent } from '@/domain/components/rbac/ProtectedComponent';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { Report } from '@/domain/types/collections';
import { useAdminLogger } from '@/domain/use-cases/admin-logger';
import FormAddReport from '@/presentation/components/form-add-report';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const ReportAddPage = () => {
  const navigate = useNavigate();
  const { logCreate } = useAdminLogger();

  const handleSave = async (data: Report) => {
    try {
      const docRef = await addDoc(collection(db, DOCUMENTS_DB.REPORTS), {
        ...data,
        createdAt: serverTimestamp(),
      });

      // Log the action
      await logCreate(DOCUMENTS_DB.REPORTS, docRef.id, data.title, data);

      toast.success('Documento guardado correctamente', {
        theme: 'colored',
      });
      navigate('/dashboard/reports');
    } catch (error) {
      console.error('Error al guardar reporte:', error);
      toast.error('Error al guardar el documento', {
        theme: 'colored',
      });
    }
  };

  return (
    <ProtectedComponent
      resource="reports"
      action="create"
      fallback={
        <div className="flex justify-center items-center min-h-96">
          <div className="text-center">
            <h2 className="text-lg font-medium text-gray-900">
              Acceso Denegado
            </h2>
            <p className="text-gray-600 mt-1">
              No tienes permisos para crear reportes
            </p>
          </div>
        </div>
      }
    >
      <div className="p-4 flex flex-col gap-4 ">
        <h1 className="text-3xl font-bold">Agregar Reporte</h1>
        <FormAddReport onSave={handleSave} />
      </div>
    </ProtectedComponent>
  );
};

export default ReportAddPage;
